import * as React from 'react';
import PageBase from '../../../components/layout/PageBase';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';

import PricePointerForm from '../../../components/pages/tools/price-pointer/PricePointerForm';
import PricePointerContent from '../../../components/pages/tools/price-pointer/PricePointerContent';
import Content from '../../../components/pages/tools/content/index';
import ToolsHeader from '../../../components/pages/tools/header/index';
import BackButton from '../../../components/utility/BackButton';

import { isMobile } from '../../../lib/getDeviceSize';

import style from '../../../styles/sass/pages/Tools.module.scss';
import { useRouter } from 'next/router';

export interface Props {
  classes: any;
  pricePoints: any[];
}

const styles = createStyles({
  card: {
    margin: '0 auto',
    padding: 16,
    width: isMobile() ? 350 : 640,
  },
});

export const PricePointer = (props: Props) => {
  const [zip, setZip] = React.useState('');
  const router = useRouter();

  const handleZipSubmit = (zipCode: string) => {
    setZip(zipCode);
  };

  const content = (needPointerContent: boolean) => {
    return (
      <Card className={props.classes.card}>
        <CardContent>
          <h3>
            Enter a zip code to see how much people have been paying relative to
            asking prices.
          </h3>
          <br className="no-mobile" />
          <div className="column">
            <PricePointerForm zip={zip} handleZipSubmit={handleZipSubmit} />
            {needPointerContent && (
              <PricePointerContent data={props.pricePoints} />
            )}
          </div>
        </CardContent>
      </Card>
    );
  };

  return (
    <PageBase title="How much should I offer on a house? | Torii Price Pointer">
      <BackButton goBack={() => router.push('/tools')} />
      <div
        className={`${style.toolContainer} tool-container ${style.pricePointer} col-xs-12 center-xs`}
      >
        <ToolsHeader
          title="Price Pointer"
          slug="price-pointer"
          subTitle="Find out the right amount to offer on a home"
        />

        <div className={`col-xs-12 ${style.toolContent} tool-content`}>
          {props.pricePoints.length > 0 ? (
            content(true)
          ) : (
            <Content>{content(false)}</Content>
          )}
        </div>
      </div>
    </PageBase>
  );
};

const mapStateToProps = (state: any) => ({
  pricePoints: state.listings.pricePoints,
  token: state.auth.token,
});

export default withStyles(styles)(connect(mapStateToProps)(PricePointer));
